
// eslint-disable-next-line no-shadow
export enum OrganizationStatus {
  // eslint-disable-next-line no-unused-vars
  active = 'Active',
  // eslint-disable-next-line no-unused-vars
  inactive = 'inactive',
  // eslint-disable-next-line no-unused-vars
  archived = 'archived',
}

// eslint-disable-next-line no-shadow
export enum OrganizationStage {
  // eslint-disable-next-line no-unused-vars
  qualification = 'Qualification',
  // eslint-disable-next-line no-unused-vars
  ongoing = 'Ongoing operations',
}

